import { Component, ElementRef, ViewChild } from "@angular/core";
import { RouterModule } from "@angular/router";
import { AppMenuComponent } from "./app.menu";
import { BrandLogoComponent } from "../../../branding/brand-logo.component";
import { LayoutService } from "../service/layout.service";

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: "[app-sidebar]",
  standalone: true,
  imports: [AppMenuComponent, RouterModule, BrandLogoComponent],
  template: ` <div class="layout-sidebar" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
    <div class="sidebar-header">
      <a [routerLink]="['/']" class="app-logo">
        <app-brand-logo variant="horizontal" className="px-8" />
      </a>
      <button
        class="layout-sidebar-anchor p-link z-2"
        type="button"
        [attr.aria-label]="'anchorButton'"
        (click)="anchor()"
      ></button>
    </div>

    <div #menuContainer class="layout-menu-container">
      <app-menu></app-menu>
    </div>
  </div>`,
})
export class AppSidebarComponent {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  timeout: any = null;

  @ViewChild("menuContainer") menuContainer!: ElementRef;
  constructor(
    public layoutService: LayoutService,
    public el: ElementRef,
  ) {}

  onMouseEnter() {
    if (!this.layoutService.layoutState().anchored) {
      if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = null;
      }

      this.layoutService.layoutState.update((state) => {
        if (!state.sidebarActive) {
          return {
            ...state,
            sidebarActive: true,
          };
        }
        return state;
      });
    }
  }

  onMouseLeave() {
    if (!this.layoutService.layoutState().anchored) {
      if (!this.timeout) {
        this.timeout = setTimeout(() => {
          this.layoutService.layoutState.update((state) => {
            if (state.sidebarActive) {
              return {
                ...state,
                sidebarActive: false,
              };
            }
            return state;
          });
        }, 300);
      }
    }
  }

  anchor() {
    this.layoutService.layoutState.update((state) => ({
      ...state,
      anchored: !state.anchored,
    }));
  }
}
